'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeGetElementPixelPosition = exports.getElementGridPosition = undefined;

var _reselect = require('reselect');

var _fp = require('lodash/fp');

var _gridSizeSelector = require('../utils/grid/gridSizeSelector');

var _elementSelector = require('./elementSelector');

// Selectors
// Lib
var getElementGridPosition = exports.getElementGridPosition = function getElementGridPosition(state, ownProps) {
    return (0, _elementSelector.getElement)(state, ownProps).getIn(['location', 'position']);
};

var makeGetElementPixelPosition = exports.makeGetElementPixelPosition = function makeGetElementPixelPosition() {
    return (0, _reselect.createSelector)(getElementGridPosition, _gridSizeSelector.getGridSize, function (elementGridPosition, gridSize) {
        return elementGridPosition.map((0, _fp.multiply)(gridSize));
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/elementPositionSelector.js
// module id = 730
// module chunks = 0